import { cn, useIsJumbo } from '@nexelem/utils';
import { forwardRef, PropsWithChildren } from 'react';

type StaticModalFooterProps = {
  className?: string;
};

export const ModalFooter = forwardRef<HTMLDivElement, PropsWithChildren<StaticModalFooterProps>>(
  ({ className, ...props }: StaticModalFooterProps, ref) => {
    const isJumbo = useIsJumbo();
    return (
      <div
        className={cn('flex items-end justify-end gap-4 py-4', isJumbo ? 'px-8' : 'px-6', className)}
        {...props}
        ref={ref}
      />
    );
  },
);

ModalFooter.displayName = 'ModalFooter';
